 <ngx-empty-layout>
 
  <router-outlet></router-outlet>
 
  
  </ngx-empty-layout>
